// extracted by mini-css-extract-plugin
export default {"container":"AuthBackground_container__Cb8ob","background":"AuthBackground_background__BkHI3","body":"AuthBackground_body__++f8i"};